import { ApiService } from '../../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigFieldService {
  constructor(private apiService: ApiService) {
  }

  GetFields() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBFields')
      .map(
      data => {
        return data;
      }
      );
  }

  GetFieldById(Id) {
    return this.apiService.get('/api/mvp/dfb/get/getDFBField?id=' + Id)
      .map(
      data => {
        return data;
      }
      );
  }


  GetGroups() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBGroups')
      .map(
      data => {
        return data;
      }
      );
  }

  AddField(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/add/field', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "e";
      }
      );
  }
  EditField(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/edit/field', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "e";
      }
      );
  }


}





// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/config_field/config_field.service.ts